/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SourceCreationRequest model module.
 * @module model/SourceCreationRequest
 * @version v0
 */
export default class SourceCreationRequest {
  /**
   * Constructs a new <code>SourceCreationRequest</code>.
   * @alias module:model/SourceCreationRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SourceCreationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SourceCreationRequest} obj Optional instance to populate.
   * @return {module:model/SourceCreationRequest} The populated <code>SourceCreationRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SourceCreationRequest();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('skipEmpties'))
        obj.skipEmpties = ApiClient.convertToType(data['skipEmpties'], 'Boolean');
      if (data.hasOwnProperty('emptyColumns'))
        obj.emptyColumns = ApiClient.convertToType(data['emptyColumns'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
SourceCreationRequest.prototype.name = undefined;

/**
 * @member {String} description
 */
SourceCreationRequest.prototype.description = undefined;

/**
 * @member {Boolean} skipEmpties
 */
SourceCreationRequest.prototype.skipEmpties = undefined;

/**
 * @member {Array.<String>} emptyColumns
 */
SourceCreationRequest.prototype.emptyColumns = undefined;

